import React, { useState } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Inicio from './components/Inicio';
import Servicios from './components/Servicios';
import Telefonia from './components/Telefonia';
import Contacto from './components/Contacto';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';
import AvisoLegal from './components/AvisoLegal';
import PoliticaPrivacidad from './components/PoliticaPrivacidad';
// import CondicionesVenta from './components/CondicionesVenta';
import PoliticaCookies from './components/PoliticaCookies';

function App() {
  const [activeSection, setActiveSection] = useState('inicio');

  const renderSection = () => {
    switch(activeSection) {
      case 'inicio':
        return <Inicio />;
      case 'servicios':
        return <Servicios />;
      case 'telefonia':
        return <Telefonia />;
      case 'contacto':
        return <Contacto />;
      case 'aviso-legal':
        return <AvisoLegal />;
      case 'privacidad':
        return <PoliticaPrivacidad />;
      case 'cookies':
        return <PoliticaCookies />;        
      default:
        return <Inicio />;
    }
  };

  return (
    <div className="app">
      <Navbar setActiveSection={setActiveSection} activeSection={activeSection} />
      <main>
        {renderSection()}
      </main>
      <CookieBanner />
      <Footer setActiveSection={setActiveSection} />
    </div>
  );
}

export default App;